var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Table',{attrs:{"stripe":"","size":"small","data":_vm.tableData,"columns":_vm.dataColumns}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }